import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";

const Login = lazy(() => import("./pages/Login/Login"));
const Dashboard = lazy(() => import("./pages/Dashboard/Dashboard"));

function App() {
  return (
    <Router>
      <Suspense fallback={<div className="p-6 text-gray-500">Đang tải trang…</div>}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard/" element={<Dashboard />} />
          <Route path="/*" element={<Dashboard />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
